import fetcher from '../lib/fetcher'
import {TSector, TCreateSector, TUpdateSector} from '../types/sector.type'

const createSector = async (sector: TCreateSector): Promise<TSector> => {
  const response = await fetcher.post<TCreateSector, TSector>(
    '/api/sector',
    sector,
  )
  return response.data!
}

const updateSector = async (sector: TUpdateSector): Promise<TSector> => {
  // id lives in the URL — keep it out of the body to match UpdateSectorSchema
  const {id, ...body} = sector
  const response = await fetcher.patch<typeof body, TSector>(
    `/api/sector/${id}`,
    body,
  )
  return response.data!
}

const deleteSector = async (sectorId: string) => {
  const response = await fetcher.del(`/api/sector/${sectorId}`)
  return response.data
}

const listSectorsByNetwork = async (networkId: string): Promise<TSector[]> => {
  const response = await fetcher.get<TSector[]>(
    `/api/network/${networkId}/sectors`,
  )
  return response.data ?? []
}

const SectorService = {
  createSector,
  updateSector,
  deleteSector,
  listSectorsByNetwork,
}

export default SectorService
